export const useNumberFormatter = (options?: Intl.NumberFormatOptions) => {
  const currency = "SBD";

  const moneyFormatter = new Intl.NumberFormat(
    "en-AU",
    options
      ? { ...options }
      : {
          style: "currency",
          currencyDisplay: "narrowSymbol",
          currency,
        }
  );

  return moneyFormatter;
};
